import {BifrostBackendNestApi} from "../gateways/BifrostBackendApi";

export default {
	async listByClientTraceId({tenantId, clientTraceId}) {
		const response = await BifrostBackendNestApi.get("/limited-discount-assignment", {
			params: {
				clientTraceId,
				tenantId
			}
		});

		return response.data;
	}
};
